



































import { Vue, Component, Prop } from "vue-property-decorator";
import Tuple from "@/models/Tuple";
import VIcon from "@/components/VIcon.vue";

@Component({
  components: {
    VIcon,
  },
})
export default class VTuple extends Vue {
  @Prop({ required: true }) readonly value!: Tuple;
  @Prop({ default: true }) readonly multiple!: boolean[];
  private insertedTuple: Tuple = null;

  created() {
    this.insertedTuple = this.value || { x: "0", y: "0", z: "0" };
  }

  private emitValues() {
    this.$emit("input", this.insertedTuple);
  }
}
